import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import MainLayout from "../components/layout/MainLayout";

import Loginpage from "../screens/Login/Loginpage";
import Home from "../screens/home/home";
import BookingPage from "../screens/mybookings/BookingPage";
import SlotsPage from "../screens/slots/slotspage";
import FacilityPage from "../screens/Facilities/FacilityPage";
import CreateSlotPage from "../screens/slots/createslotpage";
import AddFacilityPage from "../screens/Facilities/addfacilitypage";
import EditFacilityPage from "../screens/Facilities/editfacilitypage";
import PitchPage from "../screens/Facilities/PitchCourtPage";
import SchedulePage from "../screens/Schedule/SchedulePage";
import DashboardPage from "../screens/dashboard/dashboard";
import ViewFacilityPage from "../screens/Facilities/viewfacilitypage";
import EditProfile from "../components/profile/editprofile/editprofile";
import AccountSetting from "../screens/AccountSetting/AccountSetting";
import ContactUs from "../screens/ContactUs/ContactUs";
import MessagesPage from "../screens/Messages/MessagesPage";
import AnalyticsPage from "../screens/Analytics/AnalyticsPage";
import NotificationsPage from "../screens/Notifications/NotificationsPage";

import ProtectedRoute from "../components/ProtectedRoute";

const AppRoutes = () => {
  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/login" element={<Loginpage />} />

      {/* Protected Routes */}
      <Route
        element={
          <ProtectedRoute>
            <MainLayout />
          </ProtectedRoute>
        }
      >
        <Route path="/" element={<Navigate to="/home" replace />} />

        <Route path="/home" element={<Home />} />
        <Route path="/Bookings" element={<BookingPage />} />
        <Route path="/Slots" element={<SlotsPage />} />
        <Route path="/Facilities" element={<FacilityPage />} />
        <Route path="/createslots" element={<CreateSlotPage />} />
        <Route path="/AddFacility" element={<AddFacilityPage />} />
        <Route path="/edit-facility" element={<EditFacilityPage />} />
        <Route path="/Pitch" element={<PitchPage />} />
        <Route path="/Schedule" element={<SchedulePage />} />
        <Route path="/Dashboard" element={<DashboardPage />} />
        <Route path="/ViewFacility" element={<ViewFacilityPage />} />
        <Route path="/Profile" element={<EditProfile />} />
        <Route path="/AccountSettings" element={<AccountSetting />} />
        <Route path="/Contactus" element={<ContactUs />} />
        <Route path="/messages" element={<MessagesPage />} />
        <Route path="/analytics" element={<AnalyticsPage />} />
        <Route path="/notifications" element={<NotificationsPage />} />
      </Route>

      {/* Catch all */}
      <Route path="*" element={<Navigate to="/home" replace />} />
    </Routes>
  );
};

export default AppRoutes;